import { render, staticRenderFns } from "./InputWrapper.vue?vue&type=template&id=56352e1e&scoped=true&"
import script from "./InputWrapper.vue?vue&type=script&lang=ts&"
export * from "./InputWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./InputWrapper.vue?vue&type=style&index=0&id=56352e1e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56352e1e",
  null
  
)

export default component.exports